//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[],[[[],"Expand",{R_:{state:''}},0,0],[[],"Destroy",{},0,0]],[]];
SPLM.CAM.PathReport = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PathReport";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PathReport.TraceType = Object.freeze({
    "Display" : "Display", "Performance" : "Performance"});

SPLM.CAM.PathReport.DumpType = Object.freeze({
    "None" : "None", "Folders" : "Folders", "Events" : "Events"});

SPLM.CAM.PathReport.Display = Object.freeze({
    "Operation" : "Operation", "Folder" : "Folder", "SelectedOnly" : "SelectedOnly"});

export default SPLM;